// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"742e2bad43ea37059bfb","655":"ab84fba652b60e1cdb87"}[chunkId] + ".js";
};